<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import AppTitleHeader from '@/components/app/TitleHeader.vue';
  import AppBox from '@/components/app/box.vue';
  export default {
    components: {
      AppTitleHeader,
      AppBox,
    },
    props: {
      patientMedicalHistories: {
        type: Array,
        default: () => [],
      },
      allergyDrugsHistory: {
        type: Array,
        default: () => [],
      },
      noneAllergyDrugsHistory: {
        type: Array,
        default: () => [],
      },
      patientDrugHistories: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>
<template>
  <v-row class="pa-4">
    <v-col cols="6">
      <app-title-header title="تاریخچه پزشکی" class="mb-4" />
      <app-box outlined max-height="135px">
        <v-chip-group column readonly>
          <v-chip v-for="{ title, id } in patientMedicalHistories" :key="id" class="all-chip">
            {{ title }}
          </v-chip>
        </v-chip-group>
      </app-box>
    </v-col>
    <v-col cols="6">
      <app-title-header title="تاریخچه دارویی" class="mb-4" />
      <app-box outlined max-height="135px">
        <v-chip-group column readonly>
          <v-chip v-for="{ title, id } in patientDrugHistories" :key="id" class="all-chip">
            {{ title }}
          </v-chip>
        </v-chip-group>
      </app-box>
    </v-col>
    <v-col cols="6">
      <app-title-header title="حساسیت دارویی" class="mb-4" />
      <app-box outlined max-height="135px">
        <v-chip-group column readonly>
          <v-chip v-for="{ title, id } in allergyDrugsHistory" :key="id" class="all-chip">
            {{ title }}
          </v-chip>
        </v-chip-group>
      </app-box>
    </v-col>
    <v-col cols="6">
      <app-title-header title="حساسیت غیر دارویی" class="mb-4" />
      <app-box outlined max-height="135px">
        <v-chip-group column readonly>
          <v-chip v-for="{ title, id } in noneAllergyDrugsHistory" :key="id" class="all-chip">
            {{ title }}
          </v-chip>
        </v-chip-group>
      </app-box>
    </v-col>
    <v-col cols="6">
      <app-title-header title="فایل ECG" class="mb-4" />
      <app-box outlined max-height="135px"></app-box>
    </v-col>
  </v-row>
</template>
